/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef, useCallback, useState } from 'react';
import { Form } from '@unform/web';
import * as yup from 'yup';
import { FormHandles } from '@unform/core';
import Input from '../../../../components/Input';
import Modal from '../../../../components/Modal';
import Button from '../../../../components/Button';
import TableLoader from '../../../../components/TableLoader';
import getValidationErrors from '../../../../utils/getValidationErrors';
import { Container } from './styles';

interface EditDepartmentModalProps {
  show: boolean;
  title: string;
  code: number;
  nome: string;
  handleClose(): void;
  handleEdit(name: string, code: number): Promise<void>;
}

const schema = yup.object().shape({
  nomeDepartamento: yup
    .string()
    .required('O nome do departamento é obrigatório'),
});

const EditDepartmentModal: React.FC<EditDepartmentModalProps> = ({
  handleClose,
  handleEdit,
  code,
  nome,
  show,
  title,
}) => {
  const formTableRef = useRef<FormHandles>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const handleSubmit = useCallback(async (data: any) => {
    try {
      formTableRef.current?.setErrors({});

      await schema.validate(data, {
        abortEarly: false,
      });
      setLoading(true);
      await handleEdit(data.nomeDepartamento, code);
      setLoading(false);
    } catch (err: any) {
      if (err instanceof yup.ValidationError) {
        const errors = getValidationErrors(err);
        formTableRef.current?.setErrors(errors);
      }
    }
  }, []);

  return (
    <Container>
      <Modal show={show} title={title} handleClose={handleClose}>
        {loading ? (
          <TableLoader />
        ) : (
          <Form ref={formTableRef} onSubmit={handleSubmit}>
            <Input
              name="nomeDepartamento"
              id="nomeDepartamento"
              label="Nome"
              schema={schema}
              defaultValue={nome}
              placeholder="Digite o nome do departamento"
            />
            <div className="buttonsContainer">
              <Button color="orange" padding="1" type="submit">
                Adicionar
              </Button>
            </div>
          </Form>
        )}
      </Modal>
    </Container>
  );
};

export default EditDepartmentModal;
